export const filter = {
  container: {
    background: {
      color: 'var(--color-yellow-100)'
    },
    border: {
      color: 'var(--color-yellow-300)'
    },
    color: 'var(--color-gray-800)'
  },
  count: {
    background: {
      color: 'var(--color-white)'
    },
    border: {
      color: 'var(--color-yellow-300)'
    },
    color: 'var(--color-gray-800)'
  },
  toggle: {
    background: {
      color: 'var(--color-yellow-200)'
    },
    border: {
      color: 'var(--color-yellow-300)'
    }
  }
};
